import { axiosHelper } from 'Services/AxiosHelper';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.';

const checkApplicationTypeFour = async (params: any, adress: string): Promise<any> => {
  const requestAdress = `${command}${adress}`;
  return (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command: requestAdress,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;
};

export default checkApplicationTypeFour;
